import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { NewPatients } from './pages/NewPatients';
import { FinancingPage } from './pages/FinancingPage';
import { AboutPage } from './pages/AboutPage';
import { BookingPage } from './pages/BookingPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostDetail } from './pages/BlogPostDetail';
import { ContactPage } from './pages/ContactPage';
import { ServicesPage } from './pages/ServicesPage';
import { DoctorsPage } from './pages/DoctorsPage';
import { AccessibilityWidget } from './components/AccessibilityWidget';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <div className="w-full h-full" data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<LandingPage data-id="element-5" />} data-id="element-4" />
          <Route path="/new-patients" element={<NewPatients data-id="element-7" />} data-id="element-6" />
          <Route path="/financing" element={<FinancingPage data-id="element-9" />} data-id="element-8" />
          <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
          <Route path="/services" element={<ServicesPage data-id="element-13" />} data-id="element-12" />
          <Route path="/doctors" element={<DoctorsPage data-id="element-15" />} data-id="element-14" />
          <Route path="/book" element={<BookingPage data-id="element-17" />} data-id="element-16" />
          <Route path="/blog" element={<BlogPage data-id="element-19" />} data-id="element-18" />
          <Route path="/blog/:id" element={<BlogPostDetail data-id="element-21" />} data-id="element-20" />
          <Route path="/contact" element={<ContactPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </BrowserRouter>
      <AccessibilityWidget data-id="element-24" />
    </div>;
}